import { render, staticRenderFns } from "./CriarPedidoDeCompraModal.vue?vue&type=template&id=5f99635c&scoped=true"
import script from "./CriarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarPedidoDeCompraModal.vue?vue&type=style&index=0&id=5f99635c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99635c",
  null
  
)

export default component.exports